import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
import { SpecraSurface } from '../ensigns/surface';
const SpecraCard = /*#__PURE__*/ React.forwardRef(({ className, elevation = 'sm', radius = 'md', ...props }, ref)=>/*#__PURE__*/ _jsx(SpecraSurface, {
        ref: ref,
        className: cn('text-card-foreground', className),
        elevation: elevation,
        radius: radius,
        ...props
    }));
SpecraCard.displayName = 'SpecraCard';
const SpecraCardHeader = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx("div", {
        ref: ref,
        className: cn('flex items-center gap-[var(--space-3)] border-b border-border px-[var(--space-card)] py-[var(--space-3-5)]', className),
        ...props
    }));
SpecraCardHeader.displayName = 'SpecraCardHeader';
const SpecraCardTitle = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx("div", {
        ref: ref,
        className: cn('text-[length:var(--fs-ui)] font-medium text-foreground', className),
        ...props
    }));
SpecraCardTitle.displayName = 'SpecraCardTitle';
const SpecraCardDescription = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx("p", {
        ref: ref,
        className: cn('m-0 text-[length:var(--fs-ui-caption)] leading-[var(--lh-snug)] text-muted-foreground', className),
        ...props
    }));
SpecraCardDescription.displayName = 'SpecraCardDescription';
const SpecraCardContent = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx("div", {
        ref: ref,
        className: cn('p-[var(--space-card)]', className),
        ...props
    }));
SpecraCardContent.displayName = 'SpecraCardContent';
const SpecraCardFooter = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx("div", {
        ref: ref,
        className: cn('flex items-center gap-[var(--space-2)] border-t border-border px-[var(--space-card)] py-[var(--space-3)]', className),
        ...props
    }));
SpecraCardFooter.displayName = 'SpecraCardFooter';
export { SpecraCard, SpecraCardContent, SpecraCardDescription, SpecraCardFooter, SpecraCardHeader, SpecraCardTitle };
